import apiClient from './client';

export interface Notification {
  id: string;
  userId: string;
  type: 'info' | 'success' | 'warning' | 'error';
  title: string;
  message: string;
  link?: string;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
}

export interface GetNotificationsParams {
  page?: number;
  limit?: number;
  isRead?: boolean;
}

export interface SendNotificationData {
  type: 'info' | 'success' | 'warning' | 'error';
  title: string;
  message: string;
  link?: string;
}

export interface SendToSquadData extends SendNotificationData {
  squadId: string;
}

export interface SendToRoleData extends SendNotificationData {
  role: string;
}

export const notificationAPI = {
  getNotifications: async (params?: GetNotificationsParams) => {
    const response = await apiClient.get('/notifications', { params });
    return response.data;
  },

  getSentNotifications: async (page?: number, limit?: number) => {
    const response = await apiClient.get('/notifications/sent', {
      params: { page, limit },
    });
    return response.data;
  },

  markAsRead: async (id: string) => {
    const response = await apiClient.post(`/notifications/${id}/read`);
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await apiClient.post('/notifications/read-all');
    return response.data;
  },

  deleteNotification: async (id: string) => {
    const response = await apiClient.delete(`/notifications/${id}`);
    return response.data;
  },

  sendToAllUsers: async (data: SendNotificationData) => {
    const response = await apiClient.post('/notifications/send/all', data);
    return response.data;
  },

  sendToSquad: async (data: SendToSquadData) => {
    const response = await apiClient.post('/notifications/send/squad', data);
    return response.data;
  },

  sendToRole: async (data: SendToRoleData) => {
    const response = await apiClient.post('/notifications/send/role', data);
    return response.data;
  },
};
